import { defaultConfig } from "../config"

export function SkeletonProduct() {
    return (
        <div class='ns-skeleton-product ns-flex ns-flex-col'>
            <div class='ns-skeleton-product-media-wrap'>
                <div class="ns-skeleton-product-media ns-skeleton-colored" />
            </div>
            <div class='ns-skeleton-product-details ns-flex ns-flex-col' >
                <div class="ns-skeleton-product-inner ns-w-100 ns-flex ns-flex-nowrap ns-lg-justify-between">
                    <div class='ns-skeleton-product-name ns-skeleton-colored' />
                    <div class='ns-skeleton-product-price ns-skeleton-colored' />
                </div>
                <div class="ns-skeleton-product-swatches ns-skeleton-colored" />
            </div>
        </div>
    )
}

export function SkeletonLoader() {
    const visualFilters = {
        images: window.NOSTO_VISUAL_FILTERS?.every(f => f.image),
        length: window.NOSTO_VISUAL_FILTERS?.length || 0,
    }

    return (
        <div class="ns-serp ns-skeleton-loader ns-w-100 ns-h-100 ns-relative">
            {visualFilters.length > 0 && (
                <div class="ns-skeleton-vfilter-wrap ns-flex ns-flex-nowrap ns-justify-center">
                    {window.NOSTO_VISUAL_FILTERS.slice(0, 4).map(f => (
                        <div key={f.label} class="ns-skeleton-vfilter ns-w-100 ns-flex ns-flex-col">
                            {visualFilters.images && (
                                <div class="ns-skeleton-colored ns-skeleton-vfilter-img" />
                            )}
                            <div class="ns-skeleton-colored ns-skeleton-vfilter-text" />
                        </div>
                    ))}
                </div>
            )}

            <div class="ns-skeleton-toolbar ns-w-100 ns-flex ns-flex-nowrap ns-items-center ns-lg-justify-between">
                <div class="ns-skeleton-filters ns-skeleton-colored" />
                <div class="ns-skeleton-sort ns-skeleton-colored" />
            </div>

            <div class="ns-skeleton-product-grid ns-w-100 ns-grid">
                {Array.from({ length: defaultConfig.serpSize }, (_, i) => (
                    <SkeletonProduct key={i} />
                ))}
            </div>
        </div>
    )
}